import ReactDOM from "react-dom";
import "./index.scss";
import App from "./containers/app/App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(<App />, document.getElementById("root"));

reportWebVitals();
